import React from "react";
import { Card, CardBody, Col, Placeholder } from "reactstrap";

const UserListLoading = () => {
    const Users = [
        { text: 'company1', value: 'value1' },
        { text: 'company2', value: 'value2' },
        { text: 'company3', value: 'value3' },
        { text: 'company4', value: 'value4' },
        { text: 'company5', value: 'value5' },
        { text: 'company6', value: 'value6' }
    ];
    
    return (
        <React.Fragment>
            {Users.map((item, key) => (
                <Col lg={2} md={3} xs={6} key={key}>
                    <Card className="team-box card border-0 mt-4">
                    <div className="team-img position-relative mx-auto">
                        <Placeholder animation="glow">
                                <Placeholder className="img-thumbnail" style={{ height: '150px', width: '150px' }} color="secondary" size="lg" xs={12} />
                            </Placeholder>
                    </div>
                    <CardBody className="team-content card-body text-center" >
                    <Placeholder animation="glow">
                                        <Placeholder color="secondary" xs={3} />
                                    </Placeholder>
                    </CardBody>
                    </Card>    
                </Col>)
            )}
        </React.Fragment>
    );
};

export default UserListLoading;